// extracted by mini-css-extract-plugin
export default {"table":"PricingTable_table__6zgOn","center":"PricingTable_center__Iavlj","bg-gray":"PricingTable_bg-gray__Jxl1a"};